const AUTH0_CLIENT_ID_PROD = 'zWuZH692tsjqouWlFxpXqMA4esTtjwlE';
const AUTH0_CLIENT_ID_ENG_QA = 'PUltF7Q6VfY3e7SrpmGzIBbdccaW7lkN';
const AUTH0_CLIENT_ID_STG = 'U7c1Q7f7hBCe2VSZWDIfykwDIwFh5JMM';
const NON_PROD_AUTH0_AUDIENCE = 'https://api.tradestation.io';
const PROD_AUTH0_AUDIENCE = 'https://api.tradestation.com';
const DEFAULT_AUTH_SCOPE = 'openid profile TradeStation offline_access';

const auth0ClientIdsByEnv = {
  local: process.env.REACT_APP_AUTH0_CLIENT_ID_LOCAL
    || process.env.REACT_APP_AUTH0_CLIENT_ID_STG
    || AUTH0_CLIENT_ID_STG,
  test: process.env.REACT_APP_AUTH0_CLIENT_ID_TEST
    || AUTH0_CLIENT_ID_ENG_QA,
  eng: process.env.REACT_APP_AUTH0_CLIENT_ID_ENG
    || AUTH0_CLIENT_ID_ENG_QA,
  qa: process.env.REACT_APP_AUTH0_CLIENT_ID_QA
    || AUTH0_CLIENT_ID_ENG_QA,
  stg: process.env.REACT_APP_AUTH0_CLIENT_ID_STG
    || AUTH0_CLIENT_ID_STG,
  production: process.env.REACT_APP_AUTH0_CLIENT_ID_PROD
    || AUTH0_CLIENT_ID_PROD,
};

const configs = {
  local: {
    env: 'local',
    awsUrl: 'https://funding-api.tradestation.io/',
    carmaUrl: 'https://api.stg.tradestation.io/funding_new',
    fastlinkUrl: 'https://api.tradestation.io/funding/fastlink/staging',
    aopUrl: 'https://ellis-staging-1.tradestation.com',
    authHost: 'https://auth.stg.tradestation.com',
    authAuthorizeHost: 'https://signin-stg.tradestation.io',
    auth0Domain: 'signin-stg.tradestation.io',
    authAudience: process.env.REACT_APP_AUTH0_AUDIENCE_LOCAL || NON_PROD_AUTH0_AUDIENCE,
    authRedirectUri: 'https://auth.stg.tradestation.com/callback0',
    authResponseType: 'code',
    authScope: DEFAULT_AUTH_SCOPE,
    auth0ClientId: auth0ClientIdsByEnv.local,
    clientCenterHost: 'https://clientcenter.tradestation.io/support/Transfer_Funds_Cashiering.aspx#',
    showDemoLogin: false,
    logglyTag: 'fundings-ui-dev',
    yodleeFastlinkUrl: 'http://localhost:3001/staging',
    plaidUrl: 'http://localhost:3001/staging',
    plaidEnabled: 'true',
    maintenance: 'false',
  },
  test: {
    env: 'test',
    awsUrl: 'https://funding-api.tradestation.io/',
    carmaUrl: 'https://api.stg.tradestation.io/funding_new',
    fastlinkUrl: 'https://api.tradestation.io/funding/fastlink/staging',
    aopUrl: 'https://ellis-staging-1.tradestation.com',
    authHost: 'https://auth.stg.tradestation.com',
    authAuthorizeHost: 'https://signin-qa.tradestation.io',
    auth0Domain: 'signin-qa.tradestation.io',
    authAudience: process.env.REACT_APP_AUTH0_AUDIENCE_TEST || NON_PROD_AUTH0_AUDIENCE,
    authRedirectUri: 'https://auth.stg.tradestation.com/callback0',
    authResponseType: 'code',
    authScope: DEFAULT_AUTH_SCOPE,
    auth0ClientId: auth0ClientIdsByEnv.test,
    clientCenterHost:
      'https://clientcenter.tradestation.io/support/Transfer_Funds_Cashiering.aspx#',
    showDemoLogin: false,
    yodleeFastlinkUrl: 'https://fastlink-api.tradestation.io/staging',
    plaidUrl: 'https://fastlink-api.tradestation.io/staging',
    plaidEnabled: 'true',
    maintenance: 'false',
    timeout : 30000,
  },
  eng: {
    env: 'eng',
    awsUrl: 'https://funding-api.tradestation.io/',
    carmaUrl: 'https://api.stg.tradestation.io/funding_new',
    fastlinkUrl: 'https://api.tradestation.io/funding/fastlink/staging',
    aopUrl: 'https://ellis-staging-1.tradestation.com',
    authHost: 'https://auth.stg.tradestation.com',
    authAuthorizeHost: 'https://signin-qa.tradestation.io',
    auth0Domain: 'signin-qa.tradestation.io',
    authAudience: process.env.REACT_APP_AUTH0_AUDIENCE_ENG || NON_PROD_AUTH0_AUDIENCE,
    authRedirectUri: 'https://auth.stg.tradestation.com/callback0',
    authResponseType: 'code',
    authScope: DEFAULT_AUTH_SCOPE,
    auth0ClientId: auth0ClientIdsByEnv.eng,
    clientCenterHost:
      'https://clientcenter.tradestation.io/support/Transfer_Funds_Cashiering.aspx#',
    showDemoLogin: false,
    yodleeFastlinkUrl: 'https://fastlink-api.tradestation.io/staging',
    plaidUrl: 'https://fastlink-api.tradestation.io/staging',
    plaidEnabled: 'true',
    maintenance: 'false',
    timeout : 30000,
  },
  qa: {
    env: 'qa',
    awsUrl: 'https://funding-api.tradestation.io/',
    carmaUrl: 'https://api.stg.tradestation.io/funding_new',
    fastlinkUrl: 'https://api.tradestation.io/funding/fastlink/staging',
    aopUrl: 'https://ellis-staging-1.tradestation.com',
    authHost: 'https://auth.stg.tradestation.com',
    authAuthorizeHost: 'https://signin-qa.tradestation.io',
    auth0Domain: 'signin-qa.tradestation.io',
    authAudience: process.env.REACT_APP_AUTH0_AUDIENCE_QA || NON_PROD_AUTH0_AUDIENCE,
    authRedirectUri: 'https://auth.stg.tradestation.com/callback0',
    authResponseType: 'code',
    authScope: DEFAULT_AUTH_SCOPE,
    auth0ClientId: auth0ClientIdsByEnv.qa,
    clientCenterHost:
      'https://clientcenter.tradestation.io/support/Transfer_Funds_Cashiering.aspx#',
    showDemoLogin: false,
    yodleeFastlinkUrl: 'https://fastlink-api.tradestation.io/staging',
    plaidUrl: 'https://fastlink-api.tradestation.io/staging',
    plaidEnabled: 'true',
    maintenance: 'false',
    timeout : 30000,
  },
  stg: {
    env: 'stg',
    awsUrl: 'https://funding-api.tradestation.io/',
    carmaUrl: 'https://api.stg.tradestation.io/funding_new',
    fastlinkUrl: 'https://api.tradestation.io/funding/fastlink/staging',
    aopUrl: 'https://ellis-staging-1.tradestation.com',
    authHost: 'https://auth.stg.tradestation.com',
    authAuthorizeHost: 'https://signin-stg.tradestation.io',
    auth0Domain: 'signin-stg.tradestation.io',
    authAudience: process.env.REACT_APP_AUTH0_AUDIENCE_STG || NON_PROD_AUTH0_AUDIENCE,
    authRedirectUri: 'https://auth.stg.tradestation.com/callback0',
    authResponseType: 'code',
    authScope: DEFAULT_AUTH_SCOPE,
    auth0ClientId: auth0ClientIdsByEnv.stg,
    clientCenterHost:
      'https://clientcenter.tradestation.io/support/Transfer_Funds_Cashiering.aspx#',
    showDemoLogin: false,
    yodleeFastlinkUrl: 'https://fastlink-api.tradestation.io/staging',
    plaidUrl: 'https://fastlink-api.tradestation.io/staging',
    plaidEnabled: 'true',
    maintenance: 'false',
    timeout : 30000,
  },
  production: {
    env: 'production',
    awsUrl: 'https://funding-api.bs.tradestation.com/',
    carmaUrl: 'https://api.tradestation.com/funding',
    fastlinkUrl: 'https://api.tradestation.com/funding/fastlink/latest',
    aopUrl: 'https://ellis-1.tradestation.com',
    authHost: 'https://auth.tradestation.com',
    authAuthorizeHost: 'https://signin.tradestation.com',
    auth0Domain: 'signin.tradestation.com',
    authAudience: process.env.REACT_APP_AUTH0_AUDIENCE_PROD || PROD_AUTH0_AUDIENCE,
    authRedirectUri: 'https://auth.tradestation.com/callback0',
    authResponseType: 'code',
    authScope: DEFAULT_AUTH_SCOPE,
    auth0ClientId: auth0ClientIdsByEnv.production,
    clientCenterHost:
      'https://clientcenter.tradestation.com/support/Transfer_Funds_Cashiering.aspx#',
    showDemoLogin: false,
    yodleeFastlinkUrl: 'https://fastlink-api.tradestation.com/latest',
    plaidUrl: 'https://fastlink-api.tradestation.com/latest',
    plaidEnabled: 'true',
    maintenance: 'false',
    timeout : 5000,
  },
};

export default (hostname = window.location.hostname) => {
  let env = 'development';

  if (hostname === 'localhost') {
    env = 'local';
  } else if (hostname === 'funding.tradestation.io') {
    env = 'test';
  } else if (hostname === 'funding-eng.cashiering.tradestation.io') {
    env = 'eng';
  } else if (hostname === 'funding-qa.cashiering.tradestation.io') {
    env = 'qa';
  } else if (hostname === 'funding-stg.cashiering.tradestation.io') {
    env = 'stg';
  } else if (hostname === 'funding.tradestation.com') {
    env = 'production';
  }

  return configs[env];
};

export const isLowerEnvironment = (envName) => {
  const env = envName || window.location.hostname;
  const lowerEnvs = ['local', 'dev', 'qa', 'stg', 'eng'];
  
  // If passed an env name directly, check against the list
  if (typeof env === 'string' && lowerEnvs.includes(env)) {
    return true;
  }
  
  // Otherwise, get config and check the env property
  const configFunc = (hostname = window.location.hostname) => {
    let configEnv = 'development';
    if (hostname === 'localhost') {
      configEnv = 'local';
    } else if (hostname === 'funding.tradestation.io') {
      configEnv = 'test';
    } else if (hostname === 'funding-eng.cashiering.tradestation.io') {
      configEnv = 'eng';
    } else if (hostname === 'funding-qa.cashiering.tradestation.io') {
      configEnv = 'qa';
    } else if (hostname === 'funding-stg.cashiering.tradestation.io') {
      configEnv = 'stg';
    } else if (hostname === 'funding.tradestation.com') {
      configEnv = 'production';
    }
    return configs[configEnv];
  };
  const config = typeof env === 'string' ? configFunc(env) : configFunc();
  return lowerEnvs.includes(config.env);
};

